import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, apiError } from "../../store/actions";
import { Row, Col, CardBody, Card, Alert, Container, Form } from "reactstrap";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import logo from "assets/images/logo.png";

const Login = props => {
  document.title = "Login";
  const dispatch = useDispatch();
  const { loginWithRedirect, isAuthenticated, user, getAccessTokenSilently } = useAuth0();

  const { error } = useSelector(state => ({
    error: state.Login.error
  }));

  // Memoize handleAuth0Login to prevent unnecessary recreations
  const handleAuth0Login = useCallback(async () => {
    console.log('Auth0 user:', user);
    console.log('Auth0 isAuthenticated:', isAuthenticated);
    if (isAuthenticated && user) {
      try {
        const token = await getAccessTokenSilently();
        
        const userData = {
          token,
          email: user.email,
          name: user.name,
          picture: user.picture,
          sub: user.sub
        };
        console.log('Redirecting to main dashboard...');
        dispatch(loginUser(userData, props.router.navigate));
      } catch (error) {
        console.error('Auth0 token error:', error);
        dispatch(apiError(error));
      }
    }
  }, [isAuthenticated, user, getAccessTokenSilently, dispatch, props.router.navigate]);

  // Watch for authentication state changes with all dependencies properly listed
  useEffect(() => {
    console.log('useEffect triggered');
    console.log('Auth0 isAuthenticated:', isAuthenticated);
    console.log('Auth0 user:', user);
    
    if (isAuthenticated && user) {
      handleAuth0Login();
    }
  }, [isAuthenticated, user, handleAuth0Login]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Login button clicked');
    try {
      await loginWithRedirect({
        authorizationParams: {
          screen_hint: 'login',
          redirect_uri: `${window.location.origin}/callback`
        }
      });
    } catch (error) {
      console.error('Login error:', error);
      dispatch(apiError(error.message));
    }
  };

  // Add initial load log
  useEffect(() => {
    console.log('Component mounted');
  }, []);

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back!</h5>
                        <p className="text-primary">Sign in to continue.</p>
                      </div>
                    </Col>
                  </Row>
                </div>

                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-primary">
                          <img src={logo} alt="" className="rounded-circle" height="34" />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    
                    <Form className="form-horizontal" onSubmit={handleSubmit}>
                      <div className="mt-3">
                        <button className="btn btn-primary btn-block w-100" type="submit">
                          Continue to Login with Auth0
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} VMS{" "}
                  <i className="mdi mdi-shield text-primary" /> by AUTHBASE
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);